import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🚨 Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 24,
          margin: 24,
          border: '2px solid #ef4444',
          borderRadius: 8,
          background: '#fef2f2',
          color: '#991b1b'
        }}>
          <h2 style={{ color: '#dc2626', marginBottom: 16 }}>🚨 Something went wrong!</h2>
          <p style={{ marginBottom: 12 }}>
            The application encountered an error and has been stopped to prevent further issues.
          </p>
          {this.state.error && (
            <details style={{ marginBottom: 16 }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                Error Details
              </summary>
              <pre style={{ 
                background: '#fee2e2', 
                padding: 12, 
                borderRadius: 4, 
                overflow: 'auto',
                fontSize: 12,
                marginTop: 8
              }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#dc2626',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 